import { isEmpty } from "lodash";
import { t } from "@/i18n-js/instance";
import { FormItemWrapper } from "@circle-react-shared/BuilderUI/Editor/DefaultEditorV2/FormItemWrapper";
import { EditorCollapsable } from "@circle-react-shared/BuilderUI/Editor/EditorCollapsable";
import { ColorField } from "@circle-react-shared/BuilderUI/Editor/fields/ColorField";
import { SliderField } from "@circle-react-shared/BuilderUI/Editor/fields/SliderField";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { useCustomColors } from "@circle-react-shared/BuilderUI/ThemeConfiguration/hooks/useCustomColors";
import { Form } from "@circle-react-uikit/Form";
import type { ButtonVariant } from "./ButtonStateSelector";
import { generateFormItemName } from "./Styles";

interface BordersProps {
  selectedButtonVariant: ButtonVariant;
}

export const Borders = ({ selectedButtonVariant }: BordersProps) => {
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();
  const {
    flattenedCssVariables,
    themeColors,
    customColors,
    handleAddCustomColor,
  } = useCustomColors();

  if (isPropertiesPanelV2) {
    return (
      <EditorCollapsable
        title={t("builder_ui.prop_type.styles.border")}
        defaultOpen
      >
        <div className="px-6 py-5">
          <ColorField
            name={generateFormItemName(selectedButtonVariant, "borderColor")}
            hideDescription
            hideBorder
            label={t("builder_ui.prop_type.styles.border_color")}
            className="!grid grid-cols-3 !items-center !p-0"
            labelWrapperClassName="inline-flex"
            childrenWrapper={FormItemWrapper}
            labelClassName="!font-normal text-xs mb-0 mr-2"
          />
        </div>
      </EditorCollapsable>
    );
  }

  return (
    <EditorCollapsable
      title={t("builder_ui.prop_type.styles.border")}
      defaultOpen
    >
      <div className="space-y-4 px-6 py-5">
        <Form.Item
          name={generateFormItemName(selectedButtonVariant, "borderColor")}
          label={t("builder_ui.prop_type.styles.border_color")}
          hideDescription
          hideBorder
          labelClassName="!font-normal !text-xs"
          className="!flex !w-full !items-center !justify-between !p-0"
        >
          <Form.ColorPickerV2
            name={generateFormItemName(selectedButtonVariant, "borderColor")}
            cssVariables={flattenedCssVariables}
            shouldResolveCssVariable={Boolean(flattenedCssVariables)}
            shouldRenderThemeColors={!isEmpty(themeColors)}
            shouldShowAlpha={false}
            themeColors={themeColors}
            customColors={customColors}
            onAddCustomColor={
              !isEmpty(themeColors) ? handleAddCustomColor : undefined
            }
          />
        </Form.Item>

        <SliderField
          name={generateFormItemName(selectedButtonVariant, "borderWidth")}
          label={t("builder_ui.prop_type.styles.border_width")}
          units={["px", "rem"]}
          step={1}
          min={0}
          max={100}
        />
      </div>
    </EditorCollapsable>
  );
};
